/**
 * Modern Propane — ZIP delivery lookup (NJ + border NY)
 */
(function (global) {
  'use strict';

  var DATA = null;
  var COMMERCIAL_LABEL = 'Next business day';

  function isZip(value) {
    return /^\d{5}$/.test(String(value || '').trim());
  }

  function normalizeZip(value) {
    return String(value || '').replace(/\D/g, '').slice(0, 5);
  }

  function loadData() {
    if (DATA) return Promise.resolve(DATA);

    var inline = document.getElementById('mp-delivery-zips-data');
    if (inline && inline.textContent) {
      try {
        DATA = JSON.parse(inline.textContent);
        return Promise.resolve(DATA);
      } catch (err) {
        /* fall through */
      }
    }

    var url =
      (global.MP_DELIVERY_ZIPS_URL || '') ||
      (document.querySelector('[data-mp-delivery-zips-url]') || {}).getAttribute?.('data-mp-delivery-zips-url');

    if (!url) {
      return Promise.reject(new Error('Missing delivery ZIP data'));
    }

    return fetch(url)
      .then(function (res) {
        if (!res.ok) throw new Error('Failed to load ZIP data');
        return res.json();
      })
      .then(function (json) {
        DATA = json;
        if (json.commercial_label) COMMERCIAL_LABEL = json.commercial_label;
        return DATA;
      });
  }

  function indexZips(data) {
    var map = Object.create(null);
    (data.zips || []).forEach(function (entry) {
      map[entry.code] = entry;
    });
    return map;
  }

  function countyScheduleFor(data, county, state) {
    return (data.county_schedules || []).find(function (s) {
      return s.county === county && s.state === state;
    });
  }

  function formatResidentialDays(schedule, fallbackDay) {
    if (schedule) {
      if (schedule.within_week) return 'Within 1 week';
      var days = schedule.days || [];
      if (days.length === 1) return days[0];
      if (days.length === 2) return days[0] + ' & ' + days[1];
      if (days.length > 2) {
        return days.slice(0, -1).join(', ') + ' & ' + days[days.length - 1];
      }
    }
    return fallbackDay || '';
  }

  function applyCountySchedule(entry, data) {
    if (!entry) return null;
    var schedule = countyScheduleFor(data, entry.county, entry.state);
    var fallbackRes = entry.residential_day;
    entry.residential_day = formatResidentialDays(schedule, fallbackRes);
    entry.residential_days =
      schedule && !schedule.within_week && schedule.days && schedule.days.length
        ? schedule.days.slice()
        : fallbackRes
          ? [fallbackRes]
          : [];
    entry.within_week = Boolean(schedule && schedule.within_week);
    entry.schedule_notes = schedule ? schedule.notes || '' : entry.schedule_notes || '';
    entry.commercial_day = COMMERCIAL_LABEL;
    entry.commercial_next_day = true;
    return entry;
  }

  function ruleForPrefix(data, code) {
    var prefix = String(code).slice(0, 3);
    return (data.prefix_rules || []).find(function (rule) {
      return rule.prefix === prefix;
    });
  }

  function fallbackEntry(data, code) {
    var rule = ruleForPrefix(data, code);
    if (!rule) return null;

    var hub = data.hubs && data.hubs[rule.hub];
    if (!hub) return null;

    return applyCountySchedule(
      {
        code: code,
        city: rule.county + ' County area',
        county: rule.county,
        state: rule.state,
        hub: rule.hub,
        hub_name: hub.name,
        hub_short: hub.short,
        residential_day: rule.res,
        commercial_day: rule.com,
        residential: true,
        commercial: true,
        pickup: true,
        inferred: true,
        page_handle:
          'propane-delivery-' +
          code +
          '-' +
          (rule.county + ' County area').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') +
          '-' +
          rule.state.toLowerCase(),
      },
      data
    );
  }

  function lookupSync(data, zip) {
    var code = normalizeZip(zip);
    if (!isZip(code)) return null;

    var map = indexZips(data);
    if (map[code]) return applyCountySchedule(Object.assign({}, map[code]), data);
    return fallbackEntry(data, code);
  }

  function lookup(zip) {
    return loadData().then(function (data) {
      return lookupSync(data, zip);
    });
  }

  function pageUrl(entry) {
    if (!entry) return '/pages/store-finder';
    return '/pages/' + (entry.page_handle || 'propane-delivery-' + entry.code);
  }

  function residentialScheduleText(entry) {
    if (!entry) return '';
    if (entry.within_week || entry.residential_day === 'Within 1 week') {
      return 'within 1 week (route-based)';
    }
    if (entry.residential_days && entry.residential_days.length > 1) {
      return entry.residential_days
        .map(function (day) {
          return day + 's';
        })
        .join(' & ');
    }
    if (entry.residential_day) {
      return entry.residential_day + 's';
    }
    return '';
  }

  function formatSchedule(entry) {
    if (!entry) return '';
    var parts = [];
    if (entry.residential) {
      parts.push('Residential grill tank delivery: ' + residentialScheduleText(entry));
    }
    if (entry.commercial) {
      parts.push('Commercial: next business day');
    }
    return parts.join(' · ');
  }

  function formatCartSchedule(entry) {
    if (!entry) return '';
    var parts = [];
    var location = entry.county + ' County, ' + entry.state;
    if (entry.residential) {
      parts.push('Residential: ' + residentialScheduleText(entry));
    }
    if (entry.commercial) {
      parts.push('Commercial: next business day');
    }
    return location + ' · ' + parts.join(' · ');
  }

  global.MPDeliveryZip = {
    loadData: loadData,
    lookup: lookup,
    lookupSync: lookupSync,
    isZip: isZip,
    normalizeZip: normalizeZip,
    pageUrl: pageUrl,
    formatSchedule: formatSchedule,
    formatCartSchedule: formatCartSchedule,
    residentialScheduleText: residentialScheduleText,
  };
})(window);
